import * as httpClient from "../../../util/httpClient";
export const stateDisclosureAPI = async (selectedState: string, disclaimerType: string, productServiceType: string, partnerId: any, retailerCode: any, product: any, countryISO: any) => {
    //contains logic for API call
    let creditDisclosureText: string="";
    const disclosurePayload = {
        DisclaimerType: disclaimerType,
        ProductServiceType: productServiceType,
        StateCode: selectedState,
        PartnerId: partnerId? partnerId : null,
        RetailerCode: retailerCode? retailerCode : null,
        Product: product? product : null,
        CountryISO: countryISO? countryISO : null
    };
    if (disclosurePayload.DisclaimerType && disclosurePayload.ProductServiceType) {
        await httpClient.sendRequest("POST", "web/partner/get-legal-content", disclosurePayload)
            .then((data: any) => {
                if (data.isSuccess) {
                    let stateContent: any = data.legalContentData.length !== 0 ?
                        data.legalContentData: null;
                    if (stateContent) {
                        creditDisclosureText = stateContent[0] && stateContent[0].legalContent ? stateContent[0].legalContent : "";
                    }
                    else {
                        creditDisclosureText = "";
                    }
                }
            })
        return creditDisclosureText;
    }
};
